export const CLIENT_RISK = {
    HIGHEST: '2',
    HIGH: '1',
    MEDIUM: '0',
    LOW: '3',
};
